import Vue from 'vue';
import Router from 'vue-router';
// eslint-disable-next-line import/no-cycle
import store from './store/storage';

const Login = () => import('./pages/auth/login/Login.vue');
const LoginExternal = () => import('./pages/auth/loginExternal/LoginExternal.vue');
const Register = () => import('./pages/auth/register/Register.vue');
const RemindPassword = () => import('./pages/auth/remindPassword/RemindPassword.vue');
const Orders = () => import('./pages/prizes/orders/Orders.vue');
const Prizes = () => import('./pages/prizes/prizes/Prizes.vue');
const EpsCard = () => import('./pages/prizes/epsCard/EpsCard.vue');
const Dashboard = () => import('./pages/profile/dashboard/Dashboard.vue');
const ProfilePassport = () => import('./pages/profile/profilePassport/ProfilePassport.vue');
const ProfileEdit = () => import('./pages/profile/profileEdit/ProfileEdit.vue');
const ProfilePurse = () => import('./pages/profile/profilePurse/ProfilePurse.vue');
const ProfileBonuses = () => import('./pages/profile/profileBonuses/ProfileBonuses.vue');
const Courses = () => import('./pages/courses/courses/Courses.vue');
const Course = () => import('./pages/courses/course/Course.vue');
const Test = () => import('./pages/courses/test/Test.vue');
const Results = () => import('./pages/courses/result/Results.vue');
const Sales = () => import('./pages/sales/sales/Sales.vue');
const AddSale = () => import('./pages/sales/addSale/AddSale.vue');
const News = () => import('./pages/news/news/News.vue');
const Publication = () => import('./pages/news/publication/Publication.vue');
const Instructions = () => import('./pages/news/instructions/Instructions.vue');
const Instruction = () => import('./pages/news/instruction/Instruction.vue');
const Tickets = () => import('./pages/tickets/tickets/Tickets.vue');
const MobileNotifications = () => import('./pages/mobileNotifications/MobileNotifications.vue');
const Feedback = () => import('./pages/feedback/Feedback.vue');
const NotFound = () => import('./pages/NotFound.vue');
const Reset = () => import('./pages/Reset.vue');
const Shop = () => import('./pages/shop/products/Products.vue');
const ShopProduct = () => import('./pages/shop/product/Product.vue');
const Cart = () => import('./pages/cart/Cart.vue');
const Actions = () => import('./pages/sales/actions/Actions.vue');
const GameList = () => import('./pages/game/list/GameList.vue');

Vue.use(Router);

const routes = [
  // { name: '', path: '/', component: Index, meta: { requiresGuest: true } },
  { name: 'login', path: '/', component: Login, meta: { requiresGuest: true } },
  { name: 'login-external', path: '/login-external/:id/:token', component: LoginExternal, props: true, meta: { requiresGuest: true } },
  { name: 'register', path: '/register/', component: Register, meta: { requiresGuest: true } },
  { name: 'remind', path: '/remind', component: RemindPassword, meta: { requiresGuest: true } },
  { name: 'orders', path: '/orders', component: Orders, meta: { requiresAuth: true, approved: true } },
  { name: 'prizes', path: '/prizes', component: Prizes, meta: { requiresAuth: true, approved: true } },
  { name: 'eps', path: '/eps/:type', component: EpsCard, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'dashboard', path: '/dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { name: 'passport', path: '/passport', component: ProfilePassport, meta: { requiresAuth: true, approved: true } },
  { name: 'profile', path: '/profile', component: ProfileEdit, meta: { requiresAuth: true, approved: true } },
  { name: 'purse', path: '/purse', component: ProfilePurse, meta: { requiresAuth: true, approved: true } },
  { name: 'bonuses', path: '/bonuses', component: ProfileBonuses, meta: { requiresAuth: true, approved: true } },
  { name: 'courses', path: '/courses', component: Courses, meta: { requiresAuth: true, approved: true } },
  { name: 'course', path: '/course/:id', component: Course, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'test', path: '/test/:id', component: Test, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'results', path: '/results/:id', component: Results, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'news', path: '/news', component: News, meta: { requiresAuth: true, approved: true } },
  { name: 'publication', path: '/publication/:id', component: Publication, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'instructions', path: '/instructions', component: Instructions, meta: { requiresAuth: true, approved: true } },
  { name: 'instruction', path: '/instruction/:id', component: Instruction, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'cart', path: '/cart', component: Cart, meta: { requiresAuth: true, approved: true } },
  { name: 'shop', path: '/shop', component: Shop, meta: { requiresAuth: true, approved: true } },
  { name: 'shop-product', path: '/shop-product/:id', component: ShopProduct, props: true, meta: { requiresAuth: true, approved: true } },
  { name: 'notifications', path: '/notifications', component: MobileNotifications, meta: { requiresAuth: true, approved: true } },
  { name: 'tickets', path: '/tickets/', component: Tickets, meta: { requiresAuth: true } },
  { path: '/sales', component: Sales, meta: { requiresAuth: true } },
  { path: '/sale/:action_id/:id', component: AddSale, props: true, meta: { requiresAuth: true } },
  { path: '/actions', component: Actions, meta: { requiresAuth: true, requiresChecked: true } },
  { path: '/games', name: 'games', component: GameList, meta: { requiresAuth: true, requiresGame: true } },
  { name: 'reset', path: '/reset', component: Reset },
  { name: 'feedback', path: '/feedback', component: Feedback },
  { name: '', path: '*', component: NotFound },
];

const router = new Router({
  mode: 'history',
  routes,
});

const skipCheckRulesRoutes = ['login-external', 'login', 'dashboard', 'feedback'];
function needCheckRules(path) {
  if (store.state.user) {
    const countSkipRoutes = skipCheckRulesRoutes.length;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < countSkipRoutes; i++) {
      if (path.includes(skipCheckRulesRoutes[i])) {
        return false;
      }
    }
    return store.state.agreedRules === false;
  }
  return false;
}

router.beforeEach((to, from, next) => {
  Vue.notify({ group: 'error', clean: true });
  const { requiresGuest, requiresAuth, approved } = to.meta;
  let isAuthenticated = false;
  let isBlocked = true;
  const storage = localStorage.getItem('promo');

  if (storage !== null) {
    const { token, user } = JSON.parse(storage);
    if (token !== undefined && token !== null) {
      isAuthenticated = true;
    }
    if (isAuthenticated && user && user.blocked_at === null) {
      isBlocked = false;
    }
  }

  if (requiresGuest && isAuthenticated) {
    next('/dashboard');
  } else if (isAuthenticated && isBlocked && approved) {
    next('/dashboard');
  } else if (requiresAuth && !isAuthenticated) {
    next('/');
  } else if (needCheckRules(to.path)) {
    setTimeout(() => {
      store.dispatch(
        'ShowError',
        'Для работы с порталом необходимо принять правила мотивационной программы!',
      );
    }, 500);
    next('/dashboard');
  } else {
    next();
  }
});

export default router;
